import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-roboto lg:pl-72" }
const _hoisted_2 = {
  key: 0,
  class: "px-4 sm:px-6 lg:px-8 mt-6 mx-8 border border-gray-900/5 rounded-md shadow-sm"
}
const _hoisted_3 = { class: "flex justify-between gap-x-4 mt-8" }
const _hoisted_4 = { class: "-mx-4 mt-8 sm:-mx-0" }
const _hoisted_5 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-dark-blue sm:pl-0 flex items-center"
    }, " Name "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "hidden px-3 py-3.5 text-left text-sm font-semibold text-dark-blue lg:table-cell"
    }, "Email"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "pr-6 py-3.5 text-left text-sm font-semibold text-dark-blue lg:table-cell"
    }, "Role"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "relative py-3.5 pl-3 pr-4 sm:pr-0"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Edit")
    ])
  ])
], -1)
const _hoisted_7 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_8 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-dark-blue sm:pl-0" }
const _hoisted_9 = { class: "hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell" }
const _hoisted_10 = { class: "whitespace-nowrap py-4 text-sm text-gray-500 relative" }
const _hoisted_11 = { class: "whitespace-nowrap py-4 text-sm font-medium text-right" }
const _hoisted_12 = { class: "relative inline-block" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "absolute right-0 z-10 mt-2 w-48 rounded-md shadow-lg bg-white"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 2,
  class: "relative z-50",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_18 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_19 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_20 = { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6" }
const _hoisted_21 = { class: "sm:flex sm:justify-center" }
const _hoisted_22 = { class: "mt-3 sm:mt-0" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-medium leading-6 text-dark-blue" }, "Sure you want to delete?", -1)
const _hoisted_24 = { class: "mt-3 mb-4" }
const _hoisted_25 = { class: "text-sm text-[#989B9E]" }
const _hoisted_26 = { class: "mt-5 sm:mt-4 sm:flex sm:justify-center gap-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminSidebar = _resolveComponent("AdminSidebar")!
  const _component_TableSearch = _resolveComponent("TableSearch")!
  const _component_UserRoleFilterButtons = _resolveComponent("UserRoleFilterButtons")!
  const _component_UserDetailsForm = _resolveComponent("UserDetailsForm")!
  const _component_Button = _resolveComponent("Button")!
  const _component_NotFound = _resolveComponent("NotFound")!
  const _component_PaginationV2 = _resolveComponent("PaginationV2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AdminSidebar, {
      showSearchField: $setup.showSearchField,
      pageTitle: $setup.pageTitle
    }, null, 8, ["showSearchField", "pageTitle"]),
    _createElementVNode("div", _hoisted_1, [
      (!$setup.selectedUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_TableSearch, {
                "style-class": 'flex justify-start',
                label: 'Search',
                placeholder: 'Search User...',
                modelValue: $setup.searchTerm,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchTerm) = $event))
              }, null, 8, ["placeholder", "modelValue"]),
              _createVNode(_component_UserRoleFilterButtons, {
                onUpdate: _cache[1] || (_cache[1] = ($event: any) => ($setup.currentFilter = $event)),
                "style-class": 'flex justify-end gap-x-4',
                "type-options": $setup.userRoleOptions,
                "model-value": $setup.currentFilter
              }, null, 8, ["type-options", "model-value"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("tbody", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedUsers, (user, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_8, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1),
                      _createElementVNode("td", _hoisted_9, _toDisplayString(user.email), 1),
                      _createElementVNode("td", _hoisted_10, _toDisplayString(user.roles[0]), 1),
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("img", {
                            src: "/img/Icons/kebab_menu.svg",
                            id: "kebab",
                            alt: "Menu",
                            class: "cursor-pointer",
                            onClick: ($event: any) => ($setup.toggleDropdown(index))
                          }, null, 8, _hoisted_13),
                          ($setup.dropdownVisible === index)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("a", {
                                  onClick: ($event: any) => ($setup.viewDetailsPage(user)),
                                  class: "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-left"
                                }, "View Details", 8, _hoisted_15)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.selectedUser)
        ? (_openBlock(), _createBlock(_component_UserDetailsForm, {
            key: 1,
            onBack: _cache[2] || (_cache[2] = ($event: any) => ($setup.handleBack())),
            onRoleUpdated: _cache[3] || (_cache[3] = (user) => $setup.handleRoleUpdate(user)),
            user: $setup.selectedUser,
            schools: $setup.schools
          }, null, 8, ["user", "schools"]))
        : _createCommentVNode("", true),
      ($setup.isDeleteModalVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("p", _hoisted_25, "Are you sure you want to delete " + _toDisplayString($setup.userToDelete?.firstName) + " " + _toDisplayString($setup.userToDelete?.lastName) + "?", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_Button, {
                      buttonText: "No, Cancel",
                      onClick: $setup.toggleDeleteModal,
                      class: "text-dark-blue border border-dark-blue py-2.5 px-4 bg-transparent rounded shadow-md"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_Button, {
                      buttonText: "Yes, Delete",
                      onClick: $setup.handleDeleteUser,
                      class: "bg-red text-white bg-orange-red py-2.5 px-4 rounded shadow-md"
                    }, null, 8, ["onClick"])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.filteredUsers && $setup.filteredUsers.length === 0)
        ? (_openBlock(), _createBlock(_component_NotFound, {
            key: 3,
            notFoundText: "User Does Not Exist"
          }))
        : _createCommentVNode("", true),
      (!$setup.selectedUser && $setup.totalPages && $setup.userSearchDto.totalUsers)
        ? (_openBlock(), _createBlock(_component_PaginationV2, {
            key: 4,
            onChange: $setup.handlePageChange,
            "search-dto": $setup.userSearchDto
          }, null, 8, ["onChange", "search-dto"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}